import { createApp } from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createGtm } from '@gtm-support/vue-gtm';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import 'flag-icons/css/flag-icons.min.css';
import '@/util/polyfill';
import addBugsnag from './bugsnag/bugsnag';
import addVueQuery from './vueQuery';
import { i18n } from '@/i18n/i18n';
import functions from '@/plugin/functions/templateFunctions';
import router from '@/routes';
import Router from '@/routes/Router.vue';
import config from './constants';

const createGlobalApp = (id: string) => {
  const app = createApp(Router);
  addBugsnag(app);
  addVueQuery(app);
  app.use(i18n);
  app.mixin(functions);
  app.use(router);
  app.use(
    createGtm({
      id: 'GTM-PLNSCQ',
      queryParams: {
        // Add URL query string when loading gtm.js with
        // GTM ID (required when using custom environments)
        gtm_auth: undefined as unknown as string,
        gtm_preview: 'env-4',
        gtm_cookies_win: 'x',
      },
      // Add your own serverside GTM script
      source: 'https://gtm.gradguard.com/4fjkmiobfrfzs.js',
      // Script can be set to `defer` to speed up page load at
      // the cost of less accurate results (in case visitor leaves
      // before script is loaded, which is unlikely but possible).
      // Defaults to false, so the script is loaded `async` by default
      defer: false,
      // Will add `async` and `defer` to the script tag
      // to not block requests for old browsers that do not support `async`
      compatibility: false,
      // Will add `nonce` to the script tag
      // nonce: '2726c7f26c',
      // defaults to true. Plugin can be disabled by
      // setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      enabled: true,
      // Whether or not display console logs debugs (optional)
      debug: !config.is.prod,
      // Whether or not to load the GTM Script
      // Helpful if you are including GTM manually,
      // but need the dataLayer functionality in your components (optional)
      // FALSE 👉 because the file is loaded in PHP side
      loadScript: false,
      // Pass the router instance to automatically sync with router (optional)
      vueRouter: router,
      // Don't trigger events for specified router names (optional)
      // ignoredViews: ['homepage'],
      // Whether or not call trackView in Vue.nextTick
      // trackOnNextTick: false,
    }),
  );
  app.mount(id);
  dayjs.extend(localizedFormat);
  dayjs().format('L LT');
  return app;
};

export default createGlobalApp;
